import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import {
  EPolicyCompany,
  IPolicyAsset,
} from 'src/app/modules/shared/models/policy.model';
import {
  DIVESTMENT_PREVIDENTIAL_ASSETS_TABLE_TABLE_KEYS,
  DIVESTMENT_LIFE_ASSETS_TABLE_TABLE_KEYS,
  DIVESTMENT_FUNDS_REDIRECTION_TABLE_KEYS,
} from './branch-switch-divestment-intesa.constants';
import { PolicyService } from 'src/app/modules/policy/policy.service';

@Component({
  selector: 'app-branch-switch-divestment-intesa',
  templateUrl: './branch-switch-divestment-intesa.component.html',
  styleUrl: './branch-switch-divestment-intesa.component.scss',
})
export class BranchSwitchDivestmentIntesaComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() policyFunds: IPolicyAsset[] = [];
  @Input() isReadOnly: boolean;
  @Output() emitFunds = new EventEmitter<any>();

  tableKeys: ITableKey[] = [];
  selectedFund: IPolicyAsset | null = null;
  destroy$ = new Subject();

  constructor(private _policyService: PolicyService) {}

  ngOnInit(): void {
    if (this.isPrevidential) {
        if (this.operationId === "_SWITR") {
            this.tableKeys = DIVESTMENT_PREVIDENTIAL_ASSETS_TABLE_TABLE_KEYS
        } else {
            this.tableKeys = DIVESTMENT_FUNDS_REDIRECTION_TABLE_KEYS;
        }
    } else {
        this.tableKeys = DIVESTMENT_LIFE_ASSETS_TABLE_TABLE_KEYS;
    }
  }
  isIncorrectValue(value): boolean {
    if (value) {
      if (value.includes('.')) {
        return true;
      } else {
        return isNaN(parseFloat(value.replace(',', '.')));
      }
    }
  }

  maxAmountLimit(fund): boolean {
    let fundAmount = fund?.fundAmount?.split('.').join('');
    fundAmount = fundAmount?.replace(',', '.');
    return parseFloat(fund.amount) > parseFloat(fundAmount);
  }

  readFunds(funds: IPolicyAsset[]) {
    this.emitFunds.emit(funds);
  }

  fundSelected(fund: IPolicyAsset) {
    this.selectedFund = fund;
    if (this.isPrevidential) {
      this.form.get('amount').setValue(fund.fundAmount);
      const fundIndex = this.policyFunds.findIndex((f) => f.fundCode === fund.fundCode)
      if (fundIndex !== -1) {
        this.policyFunds = this.policyFunds.map((f) => {
            f.selected = false;
            f.amount = 0;
            return f;
        })
        this.policyFunds[fundIndex].amount = fund.fundAmount;
        this.policyFunds[fundIndex].selected = true;
      }
    }
  }

  get showFunds(): boolean {
    return this.policyFunds && this.policyFunds.length > 0;
  }

  get totalDisinvestmentAmount(): number {
    // if (this.isPrevidential && this.selectedFund) {
    //     let amount = this.selectedFund.fundAmount;
    //     amount = amount?.replace(/\./g, '');
    //     amount = amount?.replace(',', '.');
    //     return parseFloat(amount);
    // }
    const value = this.policyFunds.reduce((acc, fund) => {
      let amount = fund?.amount;
      amount = amount?.replace(/\./g, '');
      amount = amount?.replace(',', '.');
      return acc + parseFloat(amount);
    }, 0);
    return value;
  }

  get isPrevidential(): boolean {
    return EPolicyCompany.ISP.includes(this._policyService.companyId);
  }

  get operationId(): string {
    return this._policyService.operationId;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
